/* eslint-disable no-console */

const THREE =  require('three'); //ok 4 textureLoader
const OrbitControls = require('three-orbitcontrols');
import JQuery from 'jquery'
let $ = JQuery

import _font from "./assets/fonts/optimer_regular.typeface.json"


//const FBXLoader = require('three-fbx-loader');
//import { OBJLoader} from 'three-obj-mtl-loader'
//var THREEM = require('three-module');
//import OrbitControls from './libs/OrbitControls'


export default class threeSceneClass{
    constructor(context){
        this.idleTime = 0;
        this.context = context;
        this.camera = null;
        this.container = null;
        this.allowAutoRotate = true;
        this.mesh = null;
        this.material = null;
        this.spritesGroup = null;
        this.textGroup = null;
        this.spriteMaterials = [];
        this.spriteMaterialsHovered = [];

        this.editorMode = this.context.params.editor360POI;
        this.POI = [];
        this.miniPoi = [];
        this.miniPoiSelected = null;
        this.visitTocheck = [];
        this.planTexture = null;
        this.visits = null;

        this.font= null;
        this.colorIndice = 0;

        this.now;
    }

    windowresize(){
        /*
        if(this.container.clientWidth == 0 || this.container.clientHeight ==0)
            setTimeout(() => {
                this.windowresize();
            }, 100);*/
        setTimeout(() => {
            this.camera.aspect = this.container.clientWidth/this.container.clientHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
            //this.context.windowresize(); 
                      
        }, 100);
    }

    init() {
        this.spriteMaterials = [];
        this.spriteMaterialsHovered = [];
        this.renderer = null;
        $.getJSON("data/visit.json",(data)=>{
            this.visits= data;            
        });

/*
        this.idleTime = 0;
        this.camera = null;
        this.container = null;
        this.allowAutoRotate = true;
        this.mesh = null;
        this.material = null;
        this.spritesGroup = null;
        this.textGroup = null;



        this.POI = [];
        this.miniPoi = [];
        this.miniPoiSelected = null;
        this.visitTocheck = [];
        this.planTexture = null;

        this.font= null;
        this.colorIndice = 0;

        this.theta= 0;
        this.phi =0;

        this.now;
*/
        this.container = document.getElementById('container');
        this.container.innerHTML = "";
        var new_element = this.container.cloneNode(true);
        this.container.parentNode.replaceChild(new_element, this.container); 
        this.container = document.getElementById('container');       
        this.camera = new THREE.PerspectiveCamera(70, this.container.clientWidth/this.container.clientHeight, 0.01, 100000);
        if(!this.editorMode)
            this.camera.position.z = 500;

        this.scene = new THREE.Scene();

        this.manager = new THREE.LoadingManager();

        this.textureLoader = new THREE.TextureLoader(this.manager);

        this.fontLoader = new THREE.FontLoader();

        this.font = this.fontLoader.parse(_font);

        this.spriteMaterials = [];
        this.spriteMaterialsHovered = [];
        for(var i=1; i <6 ; i++){
            this.textureLoader.load('img/textures/circle/circle' + i + '.png', (texture) =>{
                var newmatos = new THREE.MeshLambertMaterial({transparent:true});  
                newmatos.map = texture;
                newmatos.emissive = new THREE.Color(0x000000);
                newmatos.emissiveMap = texture;
                newmatos.emissiveIntensity = 1;
                this.spriteMaterials.push(newmatos);
                var newHoverMatos = new THREE.MeshLambertMaterial(newmatos);
                newHoverMatos.emissive = new THREE.Color(0xff0000);
                this.spriteMaterialsHovered.push(newHoverMatos);
            });
        }




        this.spritesGroup = new THREE.Object3D();
        this.scene.add(this.spritesGroup);

        this.renderer = new THREE.WebGLRenderer({antialias: true});
        this.renderer.setClearColor(0xffffff);
        this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
        this.container.appendChild(this.renderer.domElement);

        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableKeys = false;
        this.controls.minDistance = 50;
        this.controls.maxDistance = 1000;        

        this.container.removeEventListener("keydown", (event) => {this.activity(); this.keyBoardHandler(event, true)},false);
        this.container.removeEventListener("mousedown", ()=> {this.activity()});
        this.container.removeEventListener("mousewheel", ()=> {this.activity()});
        window.removeEventListener("resize", ()=> {this.windowresize()} );
        this.container.removeEventListener("mousemove", (event)=> {this.overlapPoi(event)});

        this.container.removeEventListener('click', (event)=>{
            this.interact(event)
        });
 
        this.container.removeEventListener('touchstart', (event)=>{
             this.interact(event)
         });           

        this.container.addEventListener("keydown", (event) => {this.activity(); this.keyBoardHandler(event, true)},false);
        this.container.addEventListener("mousedown", ()=> {this.activity()});
        this.container.addEventListener("mousewheel", ()=> {this.activity()});
        window.addEventListener("resize", ()=> {this.windowresize()} );
        this.container.addEventListener("mousemove", (event)=> {this.overlapPoi(event)});

       this.container.addEventListener('click', (event)=>{
           this.interact(event)
       });

       this.container.addEventListener('touchstart', (event)=>{
            this.interact(event)
        });   
        if(this.editorMode){
            this.container.addEventListener("dblclick", (event)=>{
                this.interact(event)
            });
        }

        this.textureLoader.load(('img/textures/02.jpg'), (texture)=>{
            this.material = new THREE.MeshBasicMaterial();
            
            this.material.map = texture;
            this.material.side = THREE.BackSide;
            var geometry =  new THREE.SphereGeometry(2000,80,50);

            this.mesh =  new THREE.Mesh(geometry, this.material);
            this.mesh.name = "sphere";
            this.mesh.scale.x = -1; // oui parce que la 3D c'est des cons surtout Mathieu ! ;)) 
            this.mesh.rotation.y = Math.PI; // voir ci-dessus
            this.scene.add(this.mesh);    
            this.loadScene();                             
        });

        this.windowresize();
        
        this.animate();
        this.inactivity();
    }

    overlapPoi(event){
        var intersects_meshes = this.rayCast(event);
        if(intersects_meshes != undefined && intersects_meshes != null && intersects_meshes.length > 0){
             intersects_meshes[0].object.hovered = true;
             this.textGroup.children[intersects_meshes[0].object._id].children[0].material.opacity = 1;
             this.textGroup.children[intersects_meshes[0].object._id].children[1].material.opacity = .4;
        }
        else
            this.unhoverPois();
    }

    interact(event){
        var intersects_meshes = this.rayCast(event);
        if(intersects_meshes != undefined && intersects_meshes != null && intersects_meshes.length > 0){
             this.loadScene(intersects_meshes[0].object.cibleImg);
        }
        else{
            intersects_meshes = this.rayCast(event, this.editorMode);
        }
    }

    unhoverPois(){
        if (this.spritesGroup != null && this.spritesGroup.children.length > 0){
            this.spritesGroup.children.forEach(sprite =>{
                sprite.hovered= false;
            });
        }
        if (this.textGroup != null && this.textGroup.children.length > 0){
            this.textGroup.children.forEach(text =>{
                text.children[0].material.opacity = 0;
                text.children[1].material.opacity = 0;
            });
        } 
    }


    getMiniPOI(appartLink){
        var filter = this.visits.spheres.filter(x=> x.appartLink == appartLink);

        filter.forEach(link =>{
            if(!this.miniPoi.includes(link))
                this.miniPoi.push(link);
        })
    }

    makeVisitData(id){
        var test = this.visits.spheres.find(x=> x.numImg == id);
        this.miniPoiSelected = id;
        this.getMiniPOI(test.appartLink);
        var image_name = "0000000000000000" + test.appartLink;
        image_name = image_name.substr(image_name.length - this.context.params.imagePlanCounterLength);     
        
        $('#planDiv').css("background", "transparent url('img/plan/"+ this.context.params.imagePlanPrefix + image_name +".png') no-repeat center center");
        $('#planDiv').css("background-size", "100% 100%");
    }

    loadScene(sceneId = null){
        var forceRotate = false;
        if(sceneId == null){
            sceneId = this.context.selectedAppart.sphereID;
            forceRotate = true;
        }
        var image_name = "0000000000000000" + sceneId;
        image_name = image_name.substr(image_name.length - this.context.params.imageSphereCounterLength); 

        this.textureLoader.load(('img/spheres/'+ this.context.params.imageSpherePrefix + image_name +'.jpg'), (texture)=>{
            this.material.map = texture;
            this.makeVisitData(sceneId)
            this.loadSprites(sceneId);
            if(forceRotate){
                var test = this.visits.spheres.find(x=> x.numImg == sceneId);
                this.controls.forceRotation(test.prefAngle);
            }
                
        });
    }

    loadSprites(sceneId){
        this.scene.remove(this.spritesGroup);
        this.spritesGroup = new THREE.Object3D();
        this.scene.remove(this.textGroup);
        this.textGroup = new THREE.Object3D();
        var test = this.visits.spheres.find(x=> x.numImg == sceneId);

        test.links.forEach(sprite=>{
            var geometry = new THREE.CircleGeometry(80,36);
            var adaptator = .85;

            var myPoi = new THREE.Mesh(geometry, this.spriteMaterial);
            myPoi.name = sprite.name;
            myPoi.hovered = false;
            myPoi._id = this.spritesGroup.children.length;
            myPoi.cibleImg = sprite.cibleImg;
            myPoi.position.x = sprite.position.x * adaptator ;
            myPoi.position.y = sprite.position.y  * adaptator;
            myPoi.position.z = sprite.position.z  * adaptator;  
            
            myPoi.lookAt(this.camera.position);
            this.spritesGroup.add(myPoi); 

            var textGeom = new THREE.TextGeometry( sprite.name, {
                font: this.font,
                size: 60,
                height: .5,
                curveSegments: 12,
                bevelEnabled: false,
            } );
            var textContainer = new THREE.Object3D();
            textContainer.position.x = sprite.position.x * adaptator;
            textContainer.position.y = sprite.position.y  * adaptator + 150 ;
            textContainer.position.z = sprite.position.z  * adaptator;  
            textContainer.lookAt(this.camera.position);             
            var material = new THREE.MeshBasicMaterial( {transparent: true, color: 0xffffff, side: THREE.DoubleSide, opacity:0} );
            var text = new THREE.Mesh( textGeom, material );  

            text.position.x -= 35 * sprite.name.length /2 ;
            textContainer.add(text);

            var backgroundPlane = new THREE.PlaneGeometry(70 * sprite.name.length, 120);
            var planeMat = new THREE.MeshBasicMaterial( {transparent: true, color: 0x00000, side: THREE.DoubleSide, opacity:0} );

            var plane = new THREE.Mesh(backgroundPlane, planeMat);
            plane.position.z -=50;
            plane.position.y +=25;
            textContainer.add(plane);
            this.textGroup.add(textContainer);
        });
        this.scene.add(this.spritesGroup);
        this.scene.add(this.textGroup);
        //this.loopMaterial()        
    }

    inactivity(){
        this.idleTime = setTimeout(() => {
            if(this.allowAutoRotate)
                this.controls.autoRotate = true;
        }, this.context.params.inactivityTimerForAutorotate * 1000); 
    }

    activity(){
        if (this.controls.autoRotate){
            this.controls.autoRotate = false;
        }          
        clearTimeout(this.idleTime);
        this.inactivity();
    }

    keyBoardHandler(event, iskeyboard){
        this.activity();
        var code;
        var defalutAngle = this.context.params.Controls360Steps || 5 ;
        var button = null;
        if(iskeyboard)
            code = event.keyCode
        else
            code = event
        switch(code){
            case 40: //bas
                this.controls.forceUp(defalutAngle*Math.PI /180);
                button = document.getElementById('btnDown');
            break;
            case 38: //haut
                this.controls.forceUp(-defalutAngle*Math.PI /180);
                button = document.getElementById('btnUp');
            break;
            case 37: //left
                this.controls.forceLeft(-defalutAngle*Math.PI /180);
                button = document.getElementById('btnLeft');
            break;
            case 39: //right
                this.controls.forceLeft(defalutAngle*Math.PI /180);
                button = document.getElementById('btnRight');
            break;
            case 109: //-
                this.controls.zoomOut(.2);
                button = document.getElementById('btnMoins');
            break;
            case 107: // +
                this.controls.zoomIn(.2);
                button = document.getElementById('btnPlus');
            break;
            case 32:
                this.allowAutoRotate = !this.allowAutoRotate;
                if(this.allowAutoRotate)
                    this.controls.autoRotate = true;
            break;
        }
        if (button != null){
            button.style.backgroundColor = '#777'; 
            setTimeout(() => {
                button.style = null;
            }, defalutAngle * 50);
        }
    }

    animate= (now)=> {
        this.now = now ;     

        if(this.spritesGroup != null){
            var i = Math.round((Math.sin(now*.01)+1) /2 * (this.spriteMaterials.length -1));
            var colorIndice = ((Math.cos(now*.0025)+1) /2) ;
            this.spritesGroup.children.forEach(sprite =>{
                if(sprite.hovered)
                    sprite.material = this.spriteMaterialsHovered[i];
                else{
                    sprite.material = this.spriteMaterials[i];
                    sprite.material.emissive = new THREE.Color(colorIndice,colorIndice,colorIndice);
                }    
            }); 
        }

        requestAnimationFrame(this.animate);
        this.controls.update();
        $("#compass.three").css("transform", "rotateZ("+ (this.controls.getAzimuthalAngle()*180/Math.PI + 90 )+"deg)");
     
        this.renderer.render(this.scene, this.camera);
    }

    rayCast(event, editor = false){

        if(this.spritesGroup == null || this.spritesGroup.children.count == 0)
            return;
       var raycaster = new THREE.Raycaster();
 
        var eventX = event.clientX == undefined ? event.touches[0].clientX : event.clientX;
        var eventY = event.clientY == undefined ? event.touches[0].clientY : event.clientY;           

        var posX = this.container.clientLeft,
            posY = this.container.clientTop;
    
        var new_X = eventX - posX;
        var new_Y = eventY - posY;
    
        var mouse3D = new THREE.Vector3(( new_X / this.container.clientWidth ) * 2 - 1,
            -( new_Y / this.container.clientHeight ) * 2 + 1,
            0.5);
    
        raycaster.setFromCamera(mouse3D, this.camera);
    
        var intersects_meshes; // = raycaster.intersectObjects(this.spritesGroup.children);  
        
        if(editor){
            intersects_meshes = raycaster.intersectObjects(this.scene.children);
            if(intersects_meshes[0].object.name =="sphere")
                console.log("intersection", intersects_meshes[0].point);
        }
        else{
            intersects_meshes = raycaster.intersectObjects(this.spritesGroup.children); 
        }
        
        return intersects_meshes; 
    }
    
    log(data){
        console.log(data);
    }
}

